import { Component, OnInit, OnDestroy } from '@angular/core';
import { CookieService } from '../services/cookie.service';
import { HttpService } from '../services/http.service';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'app-cookie-alert',
  templateUrl: './cookie-alert.component.html',
  styleUrls: ['./cookie-alert.component.sass']
})
export class CookieAlertComponent implements OnInit, OnDestroy {

  display: boolean = false;
  message: any = 'serwis kożysta z cookies';

  langugeObsSubscribe: any;
  textObsSubscribe: any;

  language: string;


  constructor(
    private cookieService: CookieService,
    private langugeService: LanguageService,
    httpService: HttpService) {
    this.langugeObsSubscribe = langugeService.languageObs().subscribe(lang => {

      this.language = lang;

      if (this.textObsSubscribe === undefined) {
        this.textObsSubscribe = httpService.cookieObservable().subscribe(data => {
          this.message = data;
        });
      }

      httpService.getText('cookie-alert', lang);
    });
  }

  ngOnInit() {
    if (this.cookieService.findCookieValue('ALLOW_COOKIES') === false &&
      this.cookieService.findCookieValue('NOT_ALLOW_COOKIES') === false) {
      this.display = true;
    }
  }

  ngOnDestroy() {
    this.langugeObsSubscribe.unsubscribe();
    this.textObsSubscribe.unsubscribe();
  }

  changeLanguage() {
    //console.log(this.language)
    if (this.language === 'pl') {
      this.langugeService.switchLanguage('en');
      return null;
    }
    if (this.language === 'en') {
      this.langugeService.switchLanguage('pl');
      return null;
    }
  }

  setAllowCookies() {
    this.cookieService.setCookieValue('ALLOW_COOKIES', 'cookies_allowed', 360);
    this.cookieService.setCookieValue('LANGUAGE', this.language, 360);
    this.display = false;
  }

  setNotAllowCookies() {
    this.cookieService.setCookieValue('NOT_ALLOW_COOKIES', 'cookies_not_allowed');
    this.display = false;
  }

}
